//INIT
import React, { useState, useEffect, useContext } from "react"

//IMPORTS
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import Radio from "@material-ui/core/Radio"
import { useHistory } from "react-router-dom"
import SettingsIcon from "@material-ui/icons/Settings"
import InputAdornment from "@material-ui/core/InputAdornment"

import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled"
import CancelIcon from "@material-ui/icons/Cancel"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import AlertFixo from "@material-ui/lab/Alert"
import EditIcon from "@material-ui/icons/Edit"
import RadioGroup from "@material-ui/core/RadioGroup"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import FormControl from "@material-ui/core/FormControl"
import RefreshIcon from "@material-ui/icons/Refresh"
import ReceiptIcon from "@material-ui/icons/Receipt"
import CircularProgress from "@material-ui/core/CircularProgress"
import Button from "@material-ui/core/Button"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk"
import { Row, Col } from "react-bootstrap"
import Avatar from "@material-ui/core/Avatar"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Divider from "@material-ui/core/Divider"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import img from "../../assets/img/image_sample_bw.png"
const qz = require("qz-tray")

export default function Teste() {
    const theme = useTheme()
    const history = useHistory()

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
    const dayName = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"]
    const monName = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "agosto",
        "outubro",
        "novembro",
        "dezembro",
    ]
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const autorizacao = localStorage.getItem("chaveSistema")

    const [impressorasQZ, setImpressorasQZ] = React.useState([])

    useEffect(() => {
        verificarSeTemQZ()
    }, [])

    async function imprimirQz(texto, qtd, impressora = "") {
        console.log("imprimirQz", texto)
        //console.log('imprimirQz')
        if (qz.websocket.isActive()) {
            if (!impressora || impressora == "vazio") {
                impressora = await qz.printers.getDefault()
            }

            console.log("impressora()", impressora, texto, qtd)
            return impressao(impressora, texto, qtd)
        }

        qz.websocket
            .connect()
            .then(() => {
                //console.log('Conectado QZ!');
                // return qz.printers.find(); //array de impressoras
                if (!impressora) {
                    impressora = qz.printers.getDefault()
                }

                const print = impressora //impressora padrao
                localStorage.setItem("impressora", JSON.stringify(print))
                return print
            })
            .then(printer => {
                console.log("impressora()", printer, texto, qtd)

                return impressao(printer, texto, qtd)
            })
            .then(() => {})
            .catch(err => {
                console.error("erro", err)
            })
    }

    const impressao = async () => {
        const printer = await qz.printers.getDefault()
        // var config = qz.configs.create(printer, { encoding: 'ISO-8859-1' });
        var config = qz.configs.create(printer, {
            bounds: null,
            colorType: "color",
            copies: 1,
            density: 0,
            duplex: false,
            fallbackDensity: null,
            interpolation: "bicubic",
            jobName: null,
            legacy: false,
            margins: 0,
            orientation: null,
            paperThickness: null,
            printerTray: null,
            rasterize: false,
            rotation: 0,
            scaleContent: true,
            size: null,
            units: "in",
            altPrinting: false,
            encoding: null,
            spool: {},
        })
        var data = [
            {
                type: "raw",
                format: "image",
                data: img,
                options: {
                    language: "ESCPOS",
                    x: "0",
                    y: "0",
                    dotDensity: "double",
                    xmlTag: "v7:Image",
                    pageWidth: "480",
                    pageHeight: "",
                },
            },
        ]

        qz.print(config, data).catch(function (e) {
            console.error(e)
        })
    }

    const verificarSeTemQZ = () => {
        if (qz.websocket.isActive()) {
            buscarImpressoras()
        } else {
            qz.websocket
                .connect()
                .then(() => {
                    qz.printers
                        .details()
                        .then(function (data) {
                            for (var i = 0; i < data.length; i++) {
                                console.log(
                                    data[i].name +
                                        " " +
                                        data[i].driver +
                                        " " +
                                        data[i].density +
                                        " " +
                                        data[i].trays
                                )
                            }
                        })
                        .catch(function (e) {
                            console.error(e)
                        })

                    buscarImpressoras()
                })
                .catch(err => {})
        }
    }

    const buscarImpressoras = async () => {
        const printers = await qz.printers.find()
        setImpressorasQZ(printers)
    }

    return (
        <div>
            <button onClick={() => impressao()}>IMPRIMIR</button>
        </div>
    )
}
